import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { SOLUTIONS } from "../data/navigation";

const Solutions = () => (
  <main data-testid="solutions-page">
    <section className="relative py-24 bg-[#00142D] overflow-hidden">
      <div className="absolute -top-32 right-0 w-[420px] h-[420px] rounded-full bg-[#1679B5]/25 blur-[110px]" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <p className="text-[11px] font-extrabold tracking-[0.22em] uppercase text-[#32B5E8] mb-4">Solutions</p>
        <h1 data-testid="solutions-heading" className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight max-w-3xl">
          One partner. <span className="ev-gradient-text">Every kind of event.</span>
        </h1>
        <p className="mt-5 text-base md:text-lg text-slate-300 max-w-2xl leading-relaxed">
          Six specialised solution worlds covering business, brand, people, live entertainment, sports and event technology — designed and delivered by one integrated team.
        </p>
        <div className="mt-8 flex flex-wrap gap-2.5">
          {SOLUTIONS.map((s) => (
            <a data-testid={`solutions-jump-${s.id}`} key={s.id} href={`#${s.id}`} className="text-xs font-bold text-slate-200 border border-white/20 bg-white/5 hover:border-[#32B5E8]/60 hover:text-white rounded-full px-4 py-2 transition-colors">
              {s.title}
            </a>
          ))}
        </div>
      </div>
    </section>

    {SOLUTIONS.map((s, i) => (
      <section data-testid={`solution-section-${s.id}`} id={s.id} key={s.id} className={`py-20 scroll-mt-24 ${i % 2 === 0 ? "bg-white" : "bg-[#F5F8FA]"}`}>
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="flex items-start justify-between gap-6 flex-wrap mb-9">
            <div>
              <p className="text-[11px] font-extrabold tracking-[0.22em] uppercase text-[#1679B5] mb-2">{String(i + 1).padStart(2, "0")}</p>
              <h2 className="text-3xl sm:text-4xl font-extrabold text-[#081D35] tracking-tight">{s.title}</h2>
              <p className="mt-2 text-base text-[#64748B]">{s.tagline}</p>
            </div>
            <Link to="/plan-your-event" className="group inline-flex items-center gap-1.5 text-sm font-bold text-[#1679B5] hover:text-[#081D35] transition-colors mt-2">
              Enquire <ArrowUpRight size={15} className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {s.items.map((item) => (
              <div key={item} id={item.toLowerCase().replace(/[^a-z0-9]+/g, "-")} className="group rounded-xl border border-slate-200 bg-white p-5 hover:border-[#32B5E8]/50 hover:shadow-[0_15px_35px_-18px_rgba(8,29,53,0.25)] hover:-translate-y-0.5 transition-all duration-300">
                <span className="block w-7 h-[3px] rounded-full bg-gradient-to-r from-[#1679B5] to-[#32B5E8] mb-4 group-hover:w-10 transition-all duration-300" />
                <p className="text-sm font-bold text-[#081D35]">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    ))}

    <section className="py-20 bg-[#081D35]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight">Not sure which solution fits?</h2>
        <p className="mt-4 text-base text-slate-400 max-w-lg mx-auto">Share your brief and we'll recommend the right format, scale and experience design.</p>
        <Link data-testid="solutions-plan-event-cta" to="/plan-your-event" className="ev-btn-primary mt-8 inline-flex items-center gap-2 text-white text-sm font-bold px-8 py-4 rounded-full">
          Plan Your Event <ArrowRight size={16} />
        </Link>
      </div>
    </section>
  </main>
);

export default Solutions;
